import React from 'react';
import { MapContainer, TileLayer, Polyline } from 'react-leaflet';
import polyline from 'polyline-encoded';
import 'leaflet/dist/leaflet.css';
import './MapModal.css';

/**
 * MapModal component - Displays an enlarged, interactive map in a modal
 */
const MapModal = ({ summaryPolyline, activityName, onClose }) => {
  if (!summaryPolyline) {
    return null;
  }

  try {
    const decoded = polyline.decode(summaryPolyline);
    const routeCoordinates = decoded.map(coord => [coord[0], coord[1]]);

    if (routeCoordinates.length === 0) {
      return null;
    }

    const latSum = routeCoordinates.reduce((sum, coord) => sum + coord[0], 0);
    const lngSum = routeCoordinates.reduce((sum, coord) => sum + coord[1], 0);
    const center = [latSum / routeCoordinates.length, lngSum / routeCoordinates.length];

    return (
      <div className="map-modal-overlay" onClick={onClose}>
        <div className="map-modal-content" onClick={(e) => e.stopPropagation()}>
          <div className="map-modal-header">
            <h3>{activityName || 'Route Map'}</h3>
            <button className="map-modal-close" onClick={onClose}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M18 6L6 18M6 6l12 12" />
              </svg>
            </button>
          </div>
          <div className="map-modal-map-container">
            <MapContainer
              key={summaryPolyline}
              center={center}
              zoom={14}
              style={{ height: '100%', width: '100%' }}
              scrollWheelZoom={true}
              dragging={true}
              zoomControl={true}
            >
              <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              />
              <Polyline
                positions={routeCoordinates}
                color="#14b8a6"
                weight={4}
                opacity={0.8}
              />
            </MapContainer>
          </div>
        </div>
      </div>
    );
  } catch (e) {
    console.error('Error rendering route map modal:', e);
    return null;
  }
};

export default MapModal;
